/**
 * Valuation date embedded in a risk-file name.
 * Real files look like mc_simulation_pnl_with_breakdown_20260803.parquet
 * or carry valuation_date=2026-08-03. Returns YYYY-MM-DD, or "" when the
 * name has no usable date.
 */
export function dateFromFilename(name) {
  if (!name) return "";
  const base = String(name).split(/[/\\]/).pop();

  const iso = [...base.matchAll(/(?:^|[^\d])(\d{4})-(\d{2})-(\d{2})(?=[^\d]|$)/g)];
  for (let i = iso.length - 1; i >= 0; i -= 1) {
    const parsed = toIsoDate(iso[i][1], iso[i][2], iso[i][3]);
    if (parsed) return parsed;
  }

  const compact = [...base.matchAll(/(?:^|[^\d])(\d{4})(\d{2})(\d{2})(?=[^\d]|$)/g)];
  for (let i = compact.length - 1; i >= 0; i -= 1) {
    const parsed = toIsoDate(compact[i][1], compact[i][2], compact[i][3]);
    if (parsed) return parsed;
  }

  return "";
}

function toIsoDate(year, month, day) {
  const y = Number(year);
  const m = Number(month);
  const d = Number(day);
  if (y < 1990 || y > 2100 || m < 1 || m > 12 || d < 1 || d > 31) return "";
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (dt.getUTCFullYear() !== y || dt.getUTCMonth() !== m - 1 || dt.getUTCDate() !== d) {
    return "";
  }
  return `${year}-${month}-${day}`;
}
